import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { useConfigUI } from '@/features/config/context'
import { CreateFlowSensor } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function createFlowSensor(payload: CreateFlowSensor): Promise<void> {
  await flowSensorApi.create(payload)
}

const useAddFlowSensor = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar, setAllowSidebar } = useConfigUI()

  return useMutation((payload: CreateFlowSensor) => createFlowSensor(payload), {
    onMutate: () => setAllowSidebar(false),
    onSuccess: async () => {
      await queryClient.refetchQueries([queryKeys.flowSensor])
      toast.success(t('addFlowSensorSuccess'))
      setAllowSidebar(true)
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
    onSettled: () => {
      setAllowSidebar(true)
    },
  })
}

export default useAddFlowSensor
